import React, { useState } from 'react';

const SendPlainTextEmail = () => {
  const [response, setResponse] = useState('');
  const [formData, setFormData] = useState({
    emailFrom: '',
    emailReplyTo: '',
    emailTo: '',
    emailCc: '',
    emailBcc: '',
    subject: '',
    breakSubject: false,
    encodeSubject: 'UTF-8',
    encodeContent: 'UTF-8',
    extraHeaders: '',
    emailBody: '',
  });

  const handleChange = (e) => {
    
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const sendEmail = (e) => {
    formData.emailBody = formData.emailBody.replace(/X/g, '\x1D');
    formData.subject = formData.subject.replace(/X/g, '\x1D');

    e.preventDefault(); // Prevent the default form submission

    fetch('/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Server response:', data);
        setResponse(data);
        alert(data.message);
      })
      .catch((error) => {
        console.error('Network error:', error);
        alert(`Network error: ${error.message}`);
      });
  };

  return (
      <main>
        <div className="container mt-4" style={{maxWidth: '700px'}}>
          <section aria-labelledby="send-email-header">
            {/* Header */}
            <h2 id="send-email-header" className="text-center">
              Send Plain Text Email
            </h2>
            <p className="text-center mt-4 mb-3">To send the email, fill out the fields below</p>
            {/* Form Section */}
            <form className="emailBg p-4 rounded">
              <div className="mb-3">
                <input
                    type="email"
                    className="form-control"
                    placeholder="Email From"
                    name="emailFrom"
                    value={formData.emailFrom}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <input
                    type="email"
                    className="form-control"
                    placeholder="Email Reply To"
                    name="emailReplyTo"
                    value={formData.emailReplyTo}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <input
                    type="email"
                    className="form-control"
                    placeholder="Email To"
                    name="emailTo"
                    value={formData.emailTo}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <input
                    type="email"
                    className="form-control"
                    placeholder="Email Cc"
                    name="emailCc"
                    value={formData.emailCc}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <input
                    type="email"
                    className="form-control"
                    placeholder="Email Bcc"
                    name="emailBcc"
                    value={formData.emailBcc}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                <div className="form-check">
                  <input
                      type="checkbox"
                      className="form-check-input"
                      id="breakSubject"
                      name="breakSubject"
                      checked={formData.breakSubject}
                      onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="breakSubject">
                    Break Subject
                  </label>
                </div>
                <span className="help">If selected, the subject will not be encoded</span>
              </div>
              <div className="mb-3">
                <label htmlFor="encodeSubject">Encode Subject</label>
                <select
                    className="form-control"
                    id="encodeSubject"
                    name="encodeSubject"
                    value={formData.encodeSubject}
                    onChange={handleChange}
                >
                  <option>UTF-8</option>
                  <option>ISO-8859-15</option>
                  <option>ISO-8859-1</option>
                  <option>US-ASCII</option>
                  <option>windows-1250</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="encodeContent">Encode Content</label>
                <select
                    className="form-control"
                    id="encodeContent"
                    name="encodeContent"
                    value={formData.encodeContent}
                    onChange={handleChange}
                >
                  <option>UTF-8</option>
                  <option>ISO-8859-15</option>
                  <option>ISO-8859-1</option>
                  <option>US-ASCII</option>
                  <option>windows-1250</option>
                </select>
              </div>
              <div className="mb-3">
                <label htmlFor="extraHeaders">Extra Headers</label>
                <textarea
                    className="form-control"
                    id="extraHeaders"
                    name="extraHeaders"
                    rows="3"
                    value={formData.extraHeaders}
                    onChange={handleChange}
                ></textarea>
                <span className="help">
            Headers that should be added to the mail. Each line contains `headername: value`.
            Example: X-MyHeader1: my value goes here
          </span>
              </div>
              <div className="mb-3">
                <label htmlFor="emailBody">Body</label>
                <textarea
                    className="form-control"
                    id="emailBody"
                    name="emailBody"
                    rows="3"
                    value={formData.emailBody}
                    onChange={handleChange}
                ></textarea>
                <span className="help">
            Funny Characters: You can add X to Subject, Extra Headers, and Body. X will be replaced by `Funny Characters` like 0x1D or 0x1C
          </span>
              </div>
              <div className="text-left">
                <button className="btn btn-secondary" onClick={sendEmail}>
                  Submit
                </button>
              </div>
            </form>
          </section>
          <p hidden>{response.success ? 'Email sent successfully' : `Error: ${response.message}`}</p>
        </div>
      </main>
        );
        };

        export default SendPlainTextEmail;